<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon small :disabled="disabled" v-bind="attrs" v-on="on" @click="$emit('click')">
        <v-icon :class="{ 'no-gradient': !gradient }" :color="color">{{ icon }}</v-icon>
      </v-btn>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
// Tarjouspyynnön rivin toimintonappi tooltipillä (sama koko luettavalla rivillä ja muokkaimessa)
export default {
  name: 'QuotationIconButton',
  props: {
    icon: { type: String, required: true },
    tooltip: { type: String, required: true },
    color: { type: String, default: undefined },
    disabled: { type: Boolean, default: false },
    // Sovelluksen liukuväri-ikoni (esim. Word); muuten tasaväri
    gradient: { type: Boolean, default: false },
  },
};
</script>
